<template>
    <div class="BatchDelete">
        <el-form :model="BatchSearch" class="batchform">
            <el-form-item :label="$t('original.languages110')" >
                <el-input v-model="BatchSearch.CounselorInfo" clearable placeholder="请输入姓名/手机号/账号/身份证号"></el-input>
            </el-form-item>

            <el-form-item :label="$t('original.languages461')">
                <el-select v-model="BatchSearch.ScheduleType" clearable placeholder="请选择">
                    <el-option
                        v-for="item in ScheduleList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item :label="$t('original.languages445')">
                <el-select v-model="BatchSearch.Campus" clearable :placeholder="$t('original.languages3')">
                    <el-option
                    v-for="item in GetDictionaryData"
                    :key="item.dicKey"
                    :label="item.cDicValue"
                    :value="item.dicKey">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item :label="$t('original.languages462')">
                <el-date-picker
                popper-class="DateStyle"
                v-model="BatchSearch.DateList"
                type="datetimerange"
                :range-separator="$t('original.languages296')"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="changetime"
                clearable
                :start-placeholder="$t('original.languages346')"
                :end-placeholder="$t('original.languages347')"
                @visible-change="datepickerFocus">
                </el-date-picker>
            </el-form-item>

            <el-form-item :label="$t('original.languages212')">&nbsp;&nbsp;
                <el-select v-model="BatchSearch.ConsultType" clearable :placeholder="$t('original.languages3')">
                    <el-option
                    v-for="item in ConsultList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-row>
                    <el-button type="primary" @click="BatchSearch.pageIndex=1;list()">{{$t('original.search')}}</el-button>
                    <el-button @click="resetclick">{{$t('original.reset')}}</el-button>
                </el-row>
            </el-form-item>
        </el-form>

        <div class="batchlist">
            <el-button type="primary" @click="DeleteScheduleClick(0)">{{$t('original.languages463')}}</el-button>
            <el-button type="primary" plain @click="DeleteScheduleClick(1)">{{$t('original.languages464')}}</el-button>
            <el-button type="primary" @click="dialogVisible=true;GetAppointmentConsultIDNameList()">{{$t('original.languages465')}}</el-button>
            <el-table
            :data="GetScheduleListData"
            :cell-style="{'text-align':'center'}"
            @selection-change="handleSelectionChange"
            style="width: 100%;margin: 10px 0;">
            <el-table-column
                type="selection"
                width="55">
            </el-table-column>
            <el-table-column
                prop="counselorName"
                :label="$t('original.languages225')">
            </el-table-column>
            <el-table-column
                prop="counselor"
                :label="$t('original.phone')">
            </el-table-column>
            <el-table-column
                prop="campus"
                :label="$t('original.languages445')"
                width="180">
            </el-table-column>
            <el-table-column
                prop="schedulDate"
                :label="$t('original.languages462')">
            </el-table-column>
            <el-table-column
                prop="weekday"
                :label="$t('original.languages466')">
            </el-table-column>
            <el-table-column
                prop="time"
                :label="$t('original.languages467')">
            </el-table-column>
            <el-table-column
                prop="schedulType"
                :label="$t('original.languages468')">
            </el-table-column>
            <el-table-column
                prop="consultType"
                :label="$t('original.languages469')">
            </el-table-column>
            <el-table-column :label="$t('original.languages49')">
                <template v-slot="scope">
                    <span class="delete_btn" @click="Deletesingle(scope.row)">{{$t('original.languages51')}}</span>
                </template>
            </el-table-column>
            </el-table>
            <el-pagination
                @current-change="handleCurrentChange"
                :current-page.sync="BatchSearch.pageIndex"
                :page-size="BatchSearch.pageSize"
                hide-on-single-page
                layout="prev, pager, next, jumper"
                :total="TotalCounts">
                </el-pagination>
        </div>

        <!-- 修改咨询方式 -->
        <el-dialog
            :visible.sync="dialogVisible"
            width="30%">
            <el-form style="width: 100%;">
                <el-form-item :label="$t('original.languages470')" >
                    <el-autocomplete
                    class="inline-input"
                    clearable
                    v-model="CounselorInfo.RealName" 
                    :fetch-suggestions="querySearch"
                    @select="handleSelect"
                    :placeholder="$t('original.languages471')">
                    <template slot-scope="{ item }">
                        <div>{{ item.RealName}}</div>
                    </template>
                </el-autocomplete>
                </el-form-item>

                <el-form-item :label="$t('original.languages212')">&nbsp;&nbsp;
                    <el-select v-model="ConsultType" clearable multiple :placeholder="$t('original.languages3')">
                        <el-option
                        v-for="item in ConsultList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('original.languages346')">&nbsp;&nbsp;
                    <el-date-picker
                    v-model="CounselorInfo.DateList"
                    type="datetime"
                    :placeholder="$t('original.languages3')"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    clearable
                    >
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">{{$t('original.cancel')}}</el-button>
                <el-button type="primary" @click="editConsultType">{{$t('original.languages59')}}</el-button>
            </span>
            </el-dialog>

    </div>
</template>
<script>
    export default{
        name:'BatchDelete',
        data() {
            return {
                dialogVisible:false,
                BatchSearch:{
                    CounselorInfo:"",//咨询师综合查询
                    ConsultType:"",//咨询方式 空-全部   0-线下  1-线上
                    ScheduleType:"",//班次类型  0-普通  1-特殊
                    Campus:"",//校区字典key
                    DateList:[],
                    pageSize:10,
                    pageIndex:0
                },
                CounselorInfo:{
                    RealName:'',
                    UserID:'',
                    DateList:''
                },
                ConsultType:'',
                PageTotal:0,
                TotalCounts:0,
                ScheduleList:[{label:'普通排班',value:0},{label:'特殊排班',value:1}],
                ConsultList:[{label:'面对面咨询',value:0},{label:'视频咨询',value:1}],
                GetDictionaryData:[],
                GetScheduleListData:[],
                TimeData:[],
                DeleteKeys:[],
                DeleteSchedulDate:'',
                AppointmentConsultIDNameList:[],
                endyear:''
            }
        },
        mounted() {
            this.BatchSearch.DateList=[this.Global.formatDate(new Date(),'YYYY-MM-DD 00:00:00'),this.Global.formatDate(new Date(),'YYYY-MM-DD 23:59:59')];
            this.GetDictionary();
            this.list();
            this.GetAppointmentConsultIDNameList();
            this.ShowTermDeploy();
        },
        methods: {
            // 获取学期列表
            ShowTermDeploy(){
                this.$Http_Post('ConsultSubscribe/ShowTermDeploy',{}).then(res=>{
                    if(res.Code == 200 || res.Code == 0){
                        res.Data.map(item=>{ 
                            if(item.StartYear == new Date().getFullYear()){
                                this.endyear=item.FinishDate;
                            }
                        });
                    }
                });
            },
            //获取咨询师列表
            GetAppointmentConsultIDNameList(){
                this.$Http_Post('ConsultSubscribe/GetAppointmentConsultIDNameList',{}).then(res=>{
                    if(res.Code==200){
                        this.AppointmentConsultIDNameList=res.Data;
                    }
                });
            },
            // 重置
            resetclick(){
                this.BatchSearch=this.$options.data().BatchSearch;
                this.BatchSearch.DateList=[this.Global.formatDate(new Date(),'YYYY-MM-DD 00:00:00'),this.Global.formatDate(new Date(),'YYYY-MM-DD 23:59:59')];
                this.list();
            },
            // 全选
            handleSelectionChange(e){
                this.DeleteKeys=[];
                for(let item of e){
                    this.DeleteKeys.push(item.schedulKey);
                }
            },
            // 分页
            handleCurrentChange(e){
                this.BatchSearch.pageIndex = e;
                this.list();
            },
            // 删除单条
            Deletesingle(e){
                this.$confirm('确认删除' + e.schedulDate+'日的'+e.time+'的咨询排班？').then(_ => {
                    this.$Http_Post('ConsultSubscribe/BatchDelSchedule',{Keys:[e.schedulKey]}).then(res=>{
                        if(res.Code==0){
                            this.$message({message:res.Message,type: 'success'});
                            this.list();
                        }else{
                            this.$message({message:res.Message,type: 'error'});
                        }
                    })
                })
            },
            DeleteScheduleClick(e){
                let Data = {};
                if(e == 0){//删除选中
                    Data['Keys']=this.DeleteKeys;
                    if(this.DeleteKeys.length<=0){
                        this.$message({message:this.$t('original.languages472'),type: 'error'});
                        return false;
                    }
                }else{
                    this.BatchSearch['SchedulDate'] = this.BatchSearch.SchedulDate;
                }
                this.$confirm(this.$t('original.languages473'))
                .then(_ => {
                this.$Http_Post('ConsultSubscribe/BatchDelSchedule',e==0?Data:this.BatchSearch).then(res=>{
                        if(res.Code==0){
                            this.$message({message:res.Message,type: 'success'});
                            this.list();
                        }else{
                            this.$message({message:res.Message,type: 'error'});
                        }
                    });
                })
            },
            // 查询列表
            list(){
                this.$Http_Post('ConsultSubscribe/GetScheduleList',this.BatchSearch).then(res=>{
                    if(res.Code == 0){
                        this.TotalCounts = res.Counts;
                        this.GetScheduleListData = res.Data;
                        this.PageTotal = Math.ceil(res.Counts/10);
                        if(!this.BatchSearch.Time){
                            this.TimeData = [];
                            for(let item of res.Data){
                                if(!this.TimeData.includes(item.time)){
                                    this.TimeData.push(item.time);
                                }
                            }
                            this.TimeData.sort();
                        }
                    }else{
                        this.$message({message:res.Message,type: 'error'});
                    }
                });
            },
            // 获取校区
            GetDictionary(){
                this.$Http_Post('User/GetDictionaryList',{DicTypCode:16}).then(res=>{
                    if(res.Code == 0){
                        this.GetDictionaryData = res.Data;
                    }else{
                        this.$message({message:res.Message,type: 'error'});
                    }
                });
            },
            // 选择日期
            changetime(val){
                if(val == null){
                    this.BatchSearch.DateList = []
                }else{
                    this.BatchSearch.DateList = val;
                }
            },
            datepickerFocus(v) {
                // if (v) {
                //     $('.DateStyle')[0].style.transform = `scale(0.5)`; //缩放系数
                //     var insetStr = $('.DateStyle')[0].style.inset.split(" ");
                //     //这里的25px根据你布局的实际位置、缩放系数来决定, 也可以动态计算。
                //     $('.DateStyle')[0].style.inset = "25px " + insetStr[1] + " " + insetStr[2] + " " + insetStr[3];
                // }
            },
            editConsultType(){
                if(this.CounselorInfo.UserID==''){
                    this.$message({message:this.$t('original.languages474'),type: 'warning'});
                    return false;
                }
                if(this.ConsultType == '' || this.ConsultType == []){
                    this.$message({message:this.$t('original.languages475'),type: 'warning'});
                    return false;
                }
                if(this.CounselorInfo.DateList ==''){
                    this.$message({message:this.$t('original.languages476'),type: 'warning'});
                    return false;
                }
                this.$Http_Post('ConsultSubscribe/BatchUpdateSchedule',{CounselorInfo:this.CounselorInfo.UserID,ConsultType:this.ConsultType.toString(),from:this.CounselorInfo.DateList}).then(res=>{
                    if(res.Code == 0 || res.Code == 200){
                        this.$message({message:res.Message,type:'success'});
                        this.dialogVisible = false;
                        this.list();
                        this.CounselorInfo = this.$options.data().CounselorInfo;
                        this.ConsultType = [];
                    }else{
                        this.$message({message:res.Message,type: 'error'});
                        this.dialogVisible = false;
                    }
                })
            },
            querySearch(queryString, cb) {
                var restaurants = this.AppointmentConsultIDNameList;
                var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                //调用callback返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.RealName.indexOf(queryString) == 0);
                };
            },
            handleSelect(item){
                this.CounselorInfo=item;
            }
        },
    }
</script>
<style>
.BatchDelete .batchform{background: #fff;padding:20px 30px 0;}
.BatchDelete .el-form-item{margin:0 20px 20px 0;display: inline-block;}
.BatchDelete .delete_btn{color: #0088FF;cursor: pointer;}
.BatchDelete .batchlist{background: #fff;padding: 20px 30px;margin-top:20px;}
.BatchDelete .el-form-item__content{display: inline-block;}
.el-picker-panel{transform: scale(0.9);}
</style>